export default __webpack_public_path__ + "static/media/instagram.d59bacc1.svg";